import { BrokerManagerPersonModel } from './brokerManagerPerson';
import { InitCompany } from './initCompany';
import { InitPersonFormModel } from './initPersonForm';


export class InitDataFormModel {
    person?: InitPersonFormModel;
    company?: InitCompany;
    broker: BrokerManagerPersonModel;
    personType: string;
    isContractingBeneficiaryInsured: boolean;
    constructor(personType = 'N') {
        if (personType == 'N') {
            this.person = new InitPersonFormModel();
        } else {
            this.company = new InitCompany();
        }
        this.broker = new BrokerManagerPersonModel();
        this.personType = personType;
        this.isContractingBeneficiaryInsured = true;
    }
}
